import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Header from './components/Header/Header';
import ProductSelector from './components/ProductSelector/ProductSelector';
import JobType from './components/JobType/JobType';
import JointDimensions from './components/JointDimensions/JointDimensions';
import TotalLength from './components/TotalLength/TotalLength';
import Calculation from './components/Calculation/Calculation';
import styles from './styles';
import { css } from 'aphrodite';
import { ResetCss } from './library';
import { ApolloClient, InMemoryCache} from '@apollo/client';
import joinSealantQuery from './queryApi/joinSealantQuery';
import Loader from './components/Loader/Loader';


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null, // graphQL request result (json)
            isImperialSystem: null,
            selectedQuantity: null,
            isQuantitySelectorError: false,
            isError: false,
            selectedProduct: false,
            isProductSelectorError: false,
            jobType: null,
            isJobTypeError: false,
            selectedType: null,
            jointDimensions: null,
            isJointDimensionsError: false,
            totalLength: null,
            isTotalLengthError: false,
            isReady: false, // ready or not for calculation (ie. all inputs have a value)
            showResult: false, // show result after calculation

        }

        this.myRefs = [];

        this.pushPageInfoDataLayer();
    }

    pushPageInfoDataLayer() {
        // TODO: à compléter
    }

    componentDidMount() {
        const { locale, context } = this.props;

        let domainName;
        let sealantData;

        if (context === 'local') {
            domainName = 'http://localhost:9112';
        }
        else if (context === 'int' || context === 'qual') {
            domainName = 'https://grout-calculator.bostik.'+ context +'.eurelis.info';
        } else {
            domainName = 'https://back.grout-calculator.bostik';
        }

        console.log(locale)

        const variables = {
            language: locale
        };

        const client = new ApolloClient({
            uri: domainName + '/graphql',
            cache: new InMemoryCache(),
        });

        client
            .query({
                query: joinSealantQuery,
                variables: variables
            })
            .then((result) => {
                sealantData = result.data.items.joinSealantPage[0];
                console.log(sealantData);

                this.setState({
                    data: sealantData,
                },()=>{

                    this.checkIfReady();
                });
            });
    }

    componentDidUpdate() {
        this.checkIfReady();
    }

    checkIfReady() {
        const { selectedProduct, jobType, jointDimensions, selectedQuantity, totalLength } = this.state;
        // console.log(selectedProduct, jobType, jointDimensions, totalLength)
        const isReady = (selectedProduct && jobType && jointDimensions && totalLength && selectedQuantity) ? true : false;
        console.log('isReady', isReady)
        if(isReady !== this.state.isReady) {
            this.setState({isReady},()=>{
                if(this.state.isReady) this.setState({isError: false});
            }, () => {
                console.log(this.state.isReady)
            });
        }
    }

    onProductSelected(product) {
        this.setState({
            selectedProduct: product,
            isProductSelectorError: false,
            showResult: false
        },()=>{
            this.checkIfReady();
        });
    }

    onQuantitySelected(quantity) {
        // Reset Quantity when Selected Product is changed
        if(quantity === null) {
            this.setState({
                selectedQuantity: null,
                isQuantitySelectorError: false,
                isImperialSystem: false,
                showResult: false
            },()=>{
                this.checkIfReady();
            });
        } else {
            this.setState({
                selectedQuantity: quantity,
                isQuantitySelectorError: false,
                isImperialSystem: quantity.fieldMetricImperial.toLowerCase() === "metric" ? false : true,
                showResult: false
            },()=>{
                this.checkIfReady();
            });
        }
    }

    onJointTypeSelected(jobType) {
        this.setState({
            jobType: jobType,
            isJobTypeError: false,
            showResult: false
        },()=>{
            this.checkIfReady();
        });
    }

    onJointDimensionsEntered(jointDimensions) {
        this.setState({
            jointDimensions: jointDimensions,
            isJointDimensionsError: !jointDimensions,
            showResult: false
        },()=>{
            this.checkIfReady();
        });
    }

    onTotalLengthEntered(totalLength) {
        this.setState({
            totalLength: totalLength,
            isTotalLengthError: !totalLength,
            showResult: false
        },()=>{
            this.checkIfReady();
        });
    }

    scrollToRef(ref) {
        ReactDOM.findDOMNode(ref).scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    onShowResult() {
        this.setState({showResult: true},()=>{
            this.scrollToRef(this.myRefs.result);
        });
    }

    throwError(){
        const { dataLayer } = this.props;
        let animating = false;
        let typeError = '';

        function pushDataLayer(error) {
            if (dataLayer !== null) {
                dataLayer.push({
                    'event' : 'eventGA',
                    'eventCategory': 'calculator',
                    'eventAction': 'form incorrect',
                    'eventLabel': error
                });
                console.log(dataLayer);
            }
        }

        this.setState({
            isError: true,
            isProductSelectorError: false,
            isQuantitySelectorError: false,
            isAreaError: false,
            isJointDimensionsError: false,
        },()=>{
            if(!this.state.selectedProduct && !this.state.isProductSelectorError) {
                animating=true;
                this.setState({isProductSelectorError: true}, ()=>{
                    this.scrollToRef(this.myRefs.productSelector);
                });
            }
            if(!this.state.selectedQuantity && !this.state.isQuantitySelectorError) {
                animating=true;
                this.setState({isQuantitySelectorError: true}, ()=>{
                    this.scrollToRef(this.myRefs.productSelector);
                });
            }
            if(!this.state.jobType && !this.state.isJobTypeError) {
                const wasAnimating = animating;
                if(!animating) {
                    animating = true;
                }
                this.setState({isJobTypeError: true}, ()=>{
                    if(!wasAnimating) {
                        this.scrollToRef(this.myRefs.jobType);
                    }
                });
            }
            if(!this.state.totalLength && !this.state.isTotalLengthError) {
                const wasAnimating = animating;
                if(!animating) {
                    animating = true;
                }
                this.setState({isTotalLengthError: true}, ()=>{
                    if(!wasAnimating) {
                        this.scrollToRef(this.myRefs.totalLength);
                    }
                });
            }
            if(!this.state.jointDimensions && !this.state.isJointDimensionsError) {
                this.setState({isJointDimensionsError: true}, ()=>{
                    if(!animating) {
                        this.scrollToRef(this.myRefs.jointDimensions);
                    }
                });
            }
            typeError   = 'missing required field';
            pushDataLayer(typeError);
        });
    }


    render() {
        const { locale, context, dataLayer } = this.props;

        let imgUrl = '';

        if (context === 'int' || context === 'qual') {
            imgUrl = 'https://grout-calculator.bostik.'+ context +'.eurelis.info';
        } else if (context === 'local' ) {
            imgUrl = '';
        } else {
            imgUrl = 'https://back.grout-calculator.bostik';
        }

        return (
            <div id="joinSealantMainContainer" className={css(styles.mainContainer)}>
                <ResetCss/>

                {this.state.data ?
                    <div>
                        <Header
                            image={this.state.data.fieldImage ? this.state.data.fieldImage.entity.fieldMediaImage.entity.url : null}
                            title={this.state.data.title}
                        />
                        <div ref={(ref)=>this.myRefs.printContainer = ref} className={css(styles.printContainer)}>
                            <ProductSelector
                                ref={(ref)=>this.myRefs.productSelector = ref}
                                title={this.state.data.fieldProductBlocTitle}
                                linkTitle={this.state.data.fieldProductCtaText}
                                products={this.state.data.products.entities}
                                onProductSelected={(product)=>this.onProductSelected(product)}
                                onQuantitySelected={(quantity)=>this.onQuantitySelected(quantity)}
                                errorLabel={this.state.data.fieldErrorMsgProduct}
                                errorPackagingLabel={this.state.data.fieldErrorMsgPackaging}
                                chooseLabel={this.state.data.fieldChooseLabel}
                                isError={this.state.isError && this.state.isProductSelectorError}
                                isQuantityError={this.state.isError && this.state.isQuantitySelectorError}
                                dataLayer={dataLayer}
                                imgUrl={imgUrl}
                                titleCertificate={this.state.data.fieldTitleCertificate}
                                titleRelatedCleaners={this.state.data.fieldTitleRelatedCleaners}
                            />
                            <JobType
                                ref={(ref)=>this.myRefs.jobType = ref}
                                title={this.state.data.fieldJointTypeBlocTitle}
                                squareJointLabel={this.state.data.fieldSquareJointLabel}
                                triangleJointLabel={this.state.data.fieldTriangleJointLabel}
                                squareJointPicto={this.state.data.fieldSquareJointPicto}
                                triangleJointPicto={this.state.data.fieldTriangleJointPicto}
                                jobType={this.state.data.jobType}
                                onJointTypeSelected={(jobType)=>this.onJointTypeSelected(jobType)}
                                errorLabel={this.state.data.fieldErrorMsgJointType}
                                isError={this.state.isError && this.state.isJobTypeError}

                            />
                            <JointDimensions
                                ref={(ref)=>this.myRefs.jointDimensions = ref}
                                title={this.state.data.fieldJointDimensionBlocTitle}
                                widthLabel={this.state.data.fieldDimensionWidthLabel}
                                depthLabel={this.state.data.fieldDimensionDepthLabel}
                                jobType={this.state.jobType}
                                isImperialSystem={this.state.isImperialSystem}
                                JointDimensionsImageTriangle={this.state.data.fieldTrianglePictoText.entity.fieldMediaImage.entity.url}
                                JointDimensionsImageSquare={this.state.data.fieldSquarePictoTxt.entity.fieldMediaImage.entity.url}
                                onJointDimensionsEntered={(jointDimensions)=>this.onJointDimensionsEntered(jointDimensions)}
                                errorLabel={this.state.data.fieldErrorMsgJointDim}
                                isError={this.state.isError && this.state.isJointDimensionsError}
                            />
                            <TotalLength
                                ref={(ref)=>this.myRefs.totalLength = ref}
                                title={this.state.data.fieldLenghtBlocTitle}
                                TotalLengthLabel={this.state.data.fieldLengthLabel}
                                TotalLengthImage={this.state.data.fieldLengthPictoWithText.entity.fieldMediaImage.entity.url}
                                onTotalLengthEntered={(totalLength)=>this.onTotalLengthEntered(totalLength)}
                                isImperialSystem={this.state.isImperialSystem}
                                errorLabel={this.state.data.fieldErrorMsgTotalLength}
                                isError={this.state.isError && this.state.isTotalLengthError}
                            />
                            <Calculation
                                ref={(ref)=>this.myRefs.result = ref}
                                buttonLabel={this.state.data.fieldCalculateButtonLabel}
                                isReady={this.state.isReady}
                                showResult={this.state.showResult}
                                product={this.state.selectedProduct}
                                jointDimensions={this.state.jointDimensions}
                                totalLength={this.state.totalLength}
                                jobType={this.state.jobType}
                                onThrowError={()=>this.throwError()}
                                onShowResult={()=>this.onShowResult()}
                                isImperialSystem={this.state.isImperialSystem}
                                title={this.state.data.fieldResultBlocTitle}
                                linkTitle={this.state.data.fieldResultProductCtaLabel}
                                findDistributorButtonLabel={this.state.data.fieldResultProductCtaLabel}
                                legalParagraph={this.state.data.fieldDisclaimer}
                                inactiveButtonLabel={this.state.data.fieldInactiveButtonLabel}
                                cartridgeLabel={this.state.data.fieldCartrigeLabel}
                                cartridgeQuantity={this.state.selectedQuantity}
                                dataLayer={dataLayer}
                                backerRodPackagelabel={this.state.data.fieldBackerRodPackageLabel}
                                noBackerRodPackageLabel={this.state.data.fieldNoBackerRodPackageLabe}
                                titleCertificate={this.state.data.fieldTitleCertificate}
                                titleRelatedCleaners={this.state.data.fieldTitleRelatedCleaners}
                            />
                        </div>
                    </div>
                :
                    <Loader imgUrl={imgUrl} />
                }
            </div>
        );

    }
}

export default App;
